// extracted by mini-css-extract-plugin
export default {"header":"AddProductModal_header__2MlXb","wrapper":"AddProductModal_wrapper__x+yUz"};